import React, { useState } from 'react'
import { Select, MenuItem } from '@mui/material'
import Button from 'base-components/Button'
import TextInput from 'components/TextInput/TextInput'
import { useTranslation } from 'react-i18next'

export interface Props {
  createUser: (event: any, resetValues: () => void) => void
  createUserStatus: { success: boolean; message: string }
}

const AdminAddUser: React.FC<Props> = ({ createUser }) => {
  const { t } = useTranslation()
  const [values, setValues] = useState({
    username: '',
    password: '',
    privilegeLevel: 0,
  })

  const handleChange = (value: string | number, name?: string) => {
    if (name) {
      setValues((prev) => ({ ...prev, [name]: value }))
    }
  }

  const resetValues = () => {
    setValues({ username: '', password: '', privilegeLevel: 0 })
  }

  const handleSubmit = (event: any) => {
    event.preventDefault()
    createUser(values, resetValues)
    return false
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex sm:flex-row flex-col flex-wrap gap-2 items-end">
        <TextInput
          placeholder={t('general.email')}
          type="email"
          name="username"
          text={values.username}
          handleChange={handleChange}
        />
        <TextInput
          type="password"
          placeholder={t('general.password')}
          name="password"
          handleChange={handleChange}
          text={values.password}
        />
        <Select
          onChange={(e: any) => handleChange(e.target.value, 'privilegeLevel')}
          className="text-gray-400"
          value={values['privilegeLevel']}
          size="small"
        >
          <MenuItem value={0}>{t('AdminAddUser.privilege.user')} </MenuItem>
          <MenuItem value={3}>{t('AdminAddUser.privilege.admin')} </MenuItem>
        </Select>
        <Button
          disabled={!values.username || !values.password}
          variant="third"
          type="submit"
        >
          {t('general.add')}
        </Button>
      </div>
    </form>
  )
}

export default AdminAddUser
